import { SxProps } from '@mui/material';
import { ProductColor } from '@globalConstants';
import { NubiTheme } from '@theme';

interface CardStyles {
  container: (productColor: ProductColor) => SxProps<NubiTheme>;
  caption: (productColor: ProductColor) => SxProps<NubiTheme>;
  expirationDate: SxProps<NubiTheme>;
  textAlignCenter: { textAlign: 'center'; zIndex: 1 };
  alignSelfEnd: { alignSelf: 'flex-end'; zIndex: 1 };
  text: (productColor: ProductColor) => SxProps<NubiTheme>;
  chip: (productColor: ProductColor) => SxProps;
  logoIcon: SxProps<NubiTheme>;
}

const styles: CardStyles = {
  container: (productColor) => ({
    position: 'relative',
    backgroundColor: productColor.main,
    borderColor: productColor.main,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 2,
    paddingX: (theme) => theme.spacing(2),
    paddingY: (theme) => theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minHeight: '166px',
    overflow: 'hidden',
  }),
  caption: (productColor) => ({
    color: productColor.contrastText,
    fontSize: '0.625rem',
    lineHeight: 1,
    zIndex: 1,
  }),
  expirationDate: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    zIndex: 1,
  },
  textAlignCenter: { textAlign: 'center', zIndex: 1 },
  alignSelfEnd: { alignSelf: 'flex-end', zIndex: 1 },
  text: (productColor) => ({
    color: productColor.contrastText,
  }),
  chip: (productColor) => ({
    zIndex: 1,
    backgroundColor: productColor.contrastText,
    color: productColor.main,
    borderColor: productColor.contrastText,
    textAlign: 'left',
    height: 'max-content',
    padding: '5px 0',
    border: 0,
    '.MuiChip-label': {
      color: productColor.main,
      width: '100%',
      whiteSpace: 'normal',
    },
    h5: {
      fontSize: '12px',
      lineHeight: 'normal',
    },
  }),
  logoIcon: {
    position: 'absolute',
    right: -20,
    bottom: 0,
    opacity: 0.1,
    zIndex: 0,
  },
};

export default styles;
